/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureCspApplication extends models.ServiceAccountCredentialsBaseForAzureCsp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureCspApplication");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureCspApplication.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureCspApplication>): ServiceAccountCredentialsForAzureCspApplication {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureCspApplication(), model);
        ServiceAccountCredentialsForAzureCspApplication.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureCspApplication>): ServiceAccountCredentialsForAzureCspApplication {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureCspApplication.newInstance(<ServiceAccountCredentialsForAzureCspApplication> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureCspApplication) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureCspApplication.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureCspApplication): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureCsp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureCspApplication.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
